import * as R from 'ramda'

import { getLanguages } from 'utils/languages'

export const EMAIL_FIELD = 'email'
export const NAME_FIELD = 'name'
export const PHONE_FIELD = 'phone'
export const LANGUAGE_FIELD = 'language'

export const getDefaultValues = languages => ({
  [NAME_FIELD]: '',
  [EMAIL_FIELD]: '',
  [PHONE_FIELD]: '',
  [LANGUAGE_FIELD]: R.filter(
    language => R.includes(R.prop('value', language), languages),
    getLanguages(),
  )[0],
})
